import { CompanyMembership } from '@xing-com/crate-common-graphql-types';

import type { ExtendedContact } from './contact';

export const addContactTracking = (origin: string) => {
  const nwtOrigin = origin.includes('subpage') ? 'subpage' : 'contacts_module';

  return (contact: ExtendedContact): ExtendedContact => {
    if (contact?.user?.connectionDegree === 1) {
      const contactType =
        contact.companyMembership === CompanyMembership.Current
          ? 'current_employee'
          : 'former_employee';

      return {
        ...contact,
        nwtOrigin,
        nwtContactType: contactType,
        user: {
          ...contact.user,
          url: `/profile/${contact?.user?.slug}${
            contact?.user?.clickReasonProfileUrlFromEntity?.code
              ? `/${contact.user?.clickReasonProfileUrlFromEntity?.code}`
              : ''
          }`,
        },
      };
    }

    return {
      ...contact,
      connectedBy: contact?.connectedBy?.map((edge) => {
        return {
          ...edge,
          nwtOrigin,
          nwtContactType: '1st_degree_contact',
          user: {
            ...edge.user,
            url: `/profile/${edge?.user?.slug}${
              edge.user?.clickReasonProfileUrlFromEntity?.code
                ? `/${edge.user?.clickReasonProfileUrlFromEntity?.code}`
                : ''
            }`,
          },
        };
      }),
      nwtOrigin,
      nwtContactType: '2nd_degree_contact',
      user: {
        ...contact.user,
        url: `/profile/${contact?.user?.slug}${
          contact?.user?.clickReasonProfileUrlFromEntity?.code
            ? `/${contact.user.clickReasonProfileUrlFromEntity.code}`
            : ''
        }`,
      },
    };
  };
};
